// @ts-check
import angular from 'angular'
import '../../shared/angular-style.css'
import './profiles.css'
import Debug from 'debug'
import {any, filter, pluck, propEq, propIs} from 'ramda'
const debug = Debug('app:workforce:index')

import { WorkerController } from './worker/worker.controller'
import workerTemplate from './worker/worker.html'
import workerMenu from './worker/menu.html'

import viewProfilesTemplate from './viewprofiles/viewProfiles.html'

import mainMenu from '../../shared/menu/menu.html'
import workforceMenu from './menu/menu.html'

import workforceTemplate from './workforce.html'
import { WorkforceController } from './workforce.controller.js'

const menu = mainMenu + workforceMenu

export default angular.module('workforce', ['ui.router'])
  .filter('favorites', () => filter(propIs(Number, 'favorite')))
  .filter('unrated', () => filter(propEq('raterId', null)))
  .filter('nosend', () => filter(propIs(Number, 'dont_sendor')))
  .filter('shiftCalc', () => {
    return (shifts) => {
      let duration
      switch (true) {
        case (shifts < 5) :
          duration = 'a few shifts'
          break
        case (shifts >= 400):
          duration = '2 years'
          break
        case (shifts >= 230):
          duration = '1 year'
          break
        case (shifts >= 100):
          duration = '6 months'
          break
        case (shifts >= 50):
          duration = '3 months'
          break
        case (shifts >= 20):
          duration = '1 month'
          break
        default:
          duration = 'a few shifts'
      }
      return duration
    }
  })
  .filter('crew', function (Crews) {
    'ngInject'

    return (workforce) => {
      let crew = Crews.getSelectedCrew()
      if (!crew || !crew.users || !crew.users.length) return []
      const crewIds = pluck('external_id', crew.users)
      return filter(worker => any(crewId => crewId === worker.external_id, crewIds), workforce)
    }
  })
  .config(function ($stateProvider) {
    'ngInject'

    $stateProvider.state('app.workforce', {
      url: '/workforce',
      resolve: {
        myCrews: (Crews) => {
          'ngInject'

          return Crews.getCrews()
        },
        regions: () => { return false },
      },
      views: {
        content: {
          controller: WorkforceController,
          controllerAs: 'wf',
          template: workforceTemplate
        },
        menu: {
          template: menu
        }
      }
    })
    .state('app.worker', {
      url: '/worker/:id',
      resolve: {
        worker: (Users, $mdDialog, $stateParams) => {
          'ngInject'

          return Users.getProfile($stateParams.id)
        },
        notes: (Users, $mdDialog, $stateParams) => {
          'ngInject'

          return Users.getNotes($stateParams.id)
          .catch((err) => {
            debug(err)
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(true)
              .title('Server Error')
              .textContent('Worker Profile Not Found')
              .ariaLabel('Server Error')
              .ok('OK')
              )
          })
        },
        application: (Users, $stateParams) => {
          'ngInject'

          return Users.fetchApplication($stateParams.id)
        },
        jobTypes: (Jobs) => {
          'ngInject'
          return Jobs.getJobTypes()
        },
        skills: (Users) => {
          'ngInject'
          return Users.getSkills()
        },
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        },
        inModal: () => { return false }
      },
      views: {
        content: {
          controller: WorkerController,
          controllerAs: 'w',
          template: workerTemplate
        },
        menu: {
          template: workerMenu
        }
      }
    })
    .state('app.workforce.worker', {
      url: '/:id',
      resolve: {
        worker: (Users, $mdDialog, $stateParams) => {
          'ngInject'

          return Users.getProfile($stateParams.id)
        },
        notes: (Users, $mdDialog, $stateParams) => {
          'ngInject'

          return Users.getNotes($stateParams.id)
          .catch((err) => {
            debug(err)
            $mdDialog.show(
              $mdDialog.alert()
              .parent(angular.element(document.querySelector('body')))
              .clickOutsideToClose(true)
              .title('Server Error')
              .textContent('Worker Profile Not Found')
              .ariaLabel('Server Error')
              .ok('OK')
              )
          })
        },
        application: (Users, $stateParams) => {
          'ngInject'

          return Users.fetchApplication($stateParams.id)
        },
        jobTypes: (Jobs) => {
          'ngInject'

          return Jobs.getJobTypes()
        },
        skills: (Users) => {
          'ngInject'
          return Users.getSkills()
        },
        company: (Companies) => {
          'ngInject'
          return Companies.getCompanyData()
        },
        inModal: () => { return false }
      },
      template: workerTemplate,
      controller: WorkerController,
      controllerAs: 'w'
    })
    $stateProvider.state('app.viewprofiles', {
      url: '/viewprofiles',
      resolve: {
        regions: (Region) => {
          'ngInject'

          return Region.getRegions()
        },
        myCrews: () => { return [] },
      },
      views: {
        content: {
          controller: WorkforceController,
          controllerAs: 'wf',
          template: viewProfilesTemplate
        },
        menu: {
          template: menu
        }
      }
    })
  })
